import React from "react"
import styled, { keyframes } from "styled-components"

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`

const Container = styled.div`
  width: 50px;
  height: 50px;
  svg {
    fill: #003a34;
    width: 100%;
    height: 100%;
  }
  .text {
    animation: ${rotate} 10s linear infinite;
    transform-origin: center center;
    transform-style: preserve-3d;
  }
  @media (min-width: 768px) {
    width: 75px;
    height: 75px;
  }
  @media (min-width: 1024px) {
    width: 100px;
    height: 100px;
  }
`

const Pineapple = () => {
  return (
    <Container>
      <svg x="0px" y="0px" viewBox="0 0 594.3 590">
        <g>
          <g>
            <path
              className="st0"
              d="M283.8,276.8c-6.8-13-17.1-24-29.5-31.8c-3.5-2.2-7.1-4.1-10.9-5.8c-0.2,0.8-0.4,1.5-0.6,2.3
			c17.2-2.1,35.1,3.3,48.2,14.6c4.2,3.6,7.6,8,11.3,12c1.1,1.1,2.8-0.6,1.7-1.7c-3.5-3.7-6.6-7.7-10.3-11.1c-3.3-3-6.9-5.6-10.7-7.8
			c-7.7-4.5-16.3-7.3-25.1-8.4c-5-0.6-10.1-0.6-15.1,0c-1,0.1-1.9,1.7-0.6,2.3c13.1,5.7,24.6,14.9,33,26.4c2.4,3.3,4.5,6.7,6.4,10.3
			C282.5,279.4,284.6,278.2,283.8,276.8L283.8,276.8z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M304.3,251.9c-2.2-3.8-5-7.2-7.9-10.5c-3.1-3.5-6.3-6.9-9.5-10.2c-6.4-6.6-13-13.2-20-19.1
			c-3.4-2.9-7.5-5.7-12.2-5.3c-0.8,0.1-1.3,0.7-1.2,1.5c0.5,2.7,2,5,3.7,7.2c1.8,2.3,3.7,4.4,5.1,7c2.9,5.4,4,11.5,5,17.4
			c0.3,1.5,2.6,0.9,2.3-0.6c-1.1-6-2.2-12-5-17.4c-1.3-2.6-3.1-4.8-5-7.1c-1.8-2.1-3.5-4.3-4-7.1c-0.4,0.5-0.8,1-1.2,1.5
			c4-0.4,7.4,2,10.4,4.5c3.4,2.8,6.6,5.9,9.7,9c6.4,6.1,12.6,12.5,18.6,19.1c3.2,3.6,6.4,7.2,8.8,11.4
			C303,254.4,305.1,253.2,304.3,251.9L304.3,251.9z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M290.1,230.8c0.3-16.1,0.5-32.1,0.8-48.2c0.1-4.5,0.2-9.1,0.2-13.6c-0.8,0.1-1.6,0.2-2.4,0.3
			c0.8,3.7,2.4,7.2,4.1,10.6c1.7,3.5,3.5,6.9,4.9,10.6c2.7,7.2,4.4,14.8,5.7,22.4c0.7,4.4,1.4,8.8,2,13.2c0.1,0.7,0.9,1,1.5,0.8
			c0.7-0.2,0.9-0.8,0.8-1.5c-1.1-7.8-2.2-15.5-3.9-23.2c-1.7-7.5-4.3-14.7-7.8-21.5c-2-3.9-4-7.7-4.8-12c-0.3-1.4-2.4-1-2.4,0.3
			c-0.3,16.1-0.5,32.1-0.8,48.2c-0.1,4.5-0.2,9.1-0.2,13.6C287.6,232.3,290.1,232.3,290.1,230.8L290.1,230.8z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M301.5,278.4c0-2.1,1-4,2.2-5.7c1.2-1.7,2.4-3.4,3.7-5c2.5-3.3,5.2-6.5,8.3-9.3c3.2-3,6.8-5.3,10.8-7.2
			c4.1-2,8.2-3.9,12.4-5.5c4.7-1.8,9.7-3,14.7-2.9c-0.2-0.8-0.4-1.5-0.6-2.3c-10.3,6.7-18.9,16.1-24.7,27c-1.6,3.1-3,6.2-4.2,9.5
			c-0.5,1.5,1.8,2.1,2.3,0.6c4-11.1,10.9-21.1,19.8-28.9c2.5-2.2,5.2-4.3,8-6.1c1-0.6,0.6-2.3-0.6-2.3c-9.6-0.1-18.6,4.1-27.1,8.1
			c-4.2,2-8.1,4.2-11.6,7.3c-3.3,2.9-6.1,6.2-8.8,9.6c-1.5,2-3.1,4-4.5,6c-1.4,2.1-2.5,4.3-2.5,6.9
			C299,279.9,301.5,279.9,301.5,278.4L301.5,278.4z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M335.6,243.8c0.8-11,8.4-21.2,18.7-25c1.3-0.5,1.1-2.3-0.3-2.4c-9-0.4-17.9,2.5-25.5,7.3
			c-7.8,4.9-14.2,11.7-19.5,19.2c-3,4.2-5.7,8.7-8.1,13.3c-0.7,1.4,1.4,2.6,2.1,1.2c8.3-15.3,19.5-30.5,36.6-36.3
			c4.7-1.6,9.5-2.4,14.5-2.2c-0.1-0.8-0.2-1.6-0.3-2.4c-11.4,4.3-19.6,15.2-20.5,27.4C333.1,245.4,335.5,245.4,335.6,243.8
			L335.6,243.8z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M289.3,216.1c-3.9-3.7-7.9-7.8-13.2-9.3c-1.1-0.3-1.8,0.9-1.4,1.8c1.2,2.6,2,5.4,2.4,8.3
			c0.2,1.4,0.2,2.8,0.2,4.3c0,1.1,0.2,2.4,1.4,2.9c0.6,0.3,1.3,0.2,1.7-0.4c0.3-0.5,0.2-1.4-0.4-1.7c-0.2-0.1-0.2-0.1-0.1,0
			c0-0.1-0.1-0.1-0.1-0.2c0-0.2,0-0.4,0-0.6c0-0.6,0-1.3,0-1.9c-0.1-1.4-0.2-2.7-0.5-4.1c-0.5-2.7-1.3-5.3-2.5-7.8
			c-0.5,0.6-0.9,1.2-1.4,1.8c4.9,1.4,8.6,5.3,12.2,8.7C288.7,218.9,290.4,217.1,289.3,216.1L289.3,216.1z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M306.4,210.6c2.8-3,4.5-6.7,6.5-10.3c1.8-3.3,3.9-6.6,7.2-8.4c-0.6-0.4-1.2-0.7-1.8-1.1
			c-0.6,5.5-1.2,10.9-1.8,16.4c-0.2,1.6,2.3,1.5,2.4,0c0.6-5.5,1.2-10.9,1.8-16.4c0.1-1-1.1-1.5-1.8-1.1c-7.5,4.1-8.6,13.2-14.2,19
			C303.6,210,305.3,211.7,306.4,210.6L306.4,210.6z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M304.3,242.8c3.5-8.8,6.6-17.8,11-26.3c2.2-4.2,4.8-8,7.5-11.8c2.7-3.8,5.4-7.6,8.2-11.3
			c2.6-3.4,5.6-6.8,9.9-7.8c-0.5-0.5-1-1-1.5-1.5c-4.5,12-8,24.4-10.4,37c-0.3,1.5,2,2.2,2.3,0.6c2.4-12.6,5.9-25,10.4-37
			c0.3-0.9-0.7-1.7-1.5-1.5c-4,1-7.1,3.7-9.6,6.8c-2.9,3.5-5.5,7.3-8.2,11c-2.9,4-5.8,8-8.2,12.3c-2.3,4.1-4.2,8.5-5.9,12.9
			c-2.1,5.3-4.2,10.6-6.3,15.8C301.3,243.6,303.7,244.3,304.3,242.8L304.3,242.8z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M316.3,298.9c-0.2,0.2-0.4,0.5-0.6,0.5c-0.3,0-0.7-0.3-0.9-0.5c-0.6-0.3-1.2-0.7-1.8-1
			c-1.2-0.7-2.4-1.4-3.6-2.2c-2.2-1.5-4.4-3.3-6-5.5c-0.4-0.5-0.7-1-1-1.6c0,0-0.4-0.9-0.5-0.9c0.2,0-0.8,0.5,0.1,0.3
			c0.2,0,0.5-0.2,0.7-0.3c1.6-0.6,3.2-1.1,4.8-1.6c3.2-0.9,6.5-1.6,9.8-2.2c2.7-0.4,5.5-1.3,8.2-0.7c0.8,0.2,1.7,0.5,2.3,1
			c0.2,0.2,0.3,0.3,0.4,0.5c0.1,0.2,0,0,0.1,0.2c0,0.1,0.1,0.5,0.1,0.2c0.1,0.6,0,0.9-0.3,1.5c-0.2,0.5-0.6,1.2-1,1.7
			c-1,1.4-2.2,2.6-3.4,3.8c-1.4,1.4-2.9,2.6-4.4,3.9C318.4,297,317.2,297.8,316.3,298.9c-1,1.2,0.7,2.9,1.7,1.7
			c0.9-1.1,2.1-2,3.2-2.9c1.5-1.3,3.1-2.7,4.6-4.1c2.2-2.1,6-5.7,4.9-9.2c-0.6-1.9-2.6-3-4.5-3.4c-3.2-0.6-6.5,0.2-9.7,0.8
			c-3.9,0.6-7.7,1.5-11.4,2.7c-0.9,0.3-1.8,0.6-2.7,0.9c-0.7,0.3-1.7,0.5-2.3,1c-1.4,1.2-0.2,3.1,0.6,4.3c2,3,4.7,5.4,7.7,7.3
			c1.5,1,3,1.9,4.6,2.8c0.8,0.5,1.7,1.1,2.7,1.1c1,0,1.7-0.6,2.3-1.3C319.1,299.4,317.3,297.7,316.3,298.9z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M330.9,290c2.4,4.5,4.8,9.1,7.2,13.6c0.6,1.1,1.2,2.3,1.8,3.4c0.3,0.6,0.6,1.1,0.9,1.7c0.2,0.5,0.3,0.7,0,1.3
			c-1.3,2.3-2.7,4.5-4.1,6.7c0.8,0.2,1.5,0.4,2.3,0.6c-0.2-1.6-1.5-2.4-3-2.1c-0.7,0.1-1.3,0.4-1.9,0.9c-0.6,0.5-1.1,1.3-1.9,1.5
			c0.5,0.3,1,0.6,1.5,0.8c-2.1-8.1-11.2-10.5-16.2-16.4c-0.3-0.4-1-0.4-1.5-0.2c-3.4,2-6.8,4.4-9.8,7c-3.4,3-5.8,6.8-8.5,10.4
			c-0.5,0.6,0,1.6,0.7,1.8c3.6,1,6.3,3.9,9,6.4c3,2.9,6.3,5.5,10,7.5c0.6,0.3,1.3,0.1,1.7-0.4c3.5-4.7,7.1-9.3,11-13.7
			c1-1.2-0.7-2.9-1.7-1.7c-4,4.6-7.8,9.3-11.4,14.2c0.6-0.1,1.1-0.3,1.7-0.4c-3.8-2.1-7.1-4.8-10.2-7.8c-2.7-2.7-5.6-5.3-9.4-6.4
			c0.2,0.6,0.5,1.2,0.7,1.8c2.6-3.4,4.9-7.1,8.1-9.9c2.8-2.5,6-4.7,9.3-6.6c-0.5-0.1-1-0.1-1.5-0.2c2.5,3,5.9,4.9,9,7.2
			c2.8,2,5.6,4.6,6.5,8.1c0.2,0.6,0.9,1,1.5,0.8c1-0.3,1.7-0.9,2.4-1.6c0.3-0.3,0.5-0.6,0.9-0.7c0.1,0,0.3,0,0.4,0
			c0.2-0.1,0.1,0.6,0-0.2c0.1,1.1,1.6,1.7,2.3,0.6c0.7-1.2,1.5-2.4,2.2-3.6c0.7-1.1,1.5-2.3,2.1-3.5c0.6-1.2,0.4-2.2-0.2-3.3
			c-0.6-1.3-1.3-2.5-2-3.7c-2.6-5-5.3-10-7.9-14.9C332.3,287.4,330.2,288.7,330.9,290L330.9,290z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M345.4,310.2c0.5-0.4,1.1-0.9,1.6-1.3c-0.7-0.3-1.4-0.6-2.1-0.9c-0.2,3.7,1.6,7.2,2.5,10.6
			c1,3.6,1.6,7.3,1.8,11.1c0.6-0.4,1.2-0.7,1.8-1.1c-2.3-1.1-4.7-2.1-6.9-3.2c-2.1-1-3.9-2.3-5.1-4.4c-0.8-1.4-2.9-0.1-2.1,1.2
			c1.3,2.2,3.1,3.8,5.4,5c2.5,1.3,5,2.3,7.5,3.5c0.8,0.4,1.9,0,1.8-1.1c-0.2-3.7-0.8-7.4-1.7-11c-0.4-1.7-1-3.5-1.6-5.2
			c-0.6-1.8-1.2-3.6-1.1-5.5c0.1-1.2-1.3-1.5-2.1-0.9c-0.5,0.4-1.1,0.9-1.6,1.3C342.4,309.5,344.2,311.2,345.4,310.2L345.4,310.2z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M283.3,298.9c1.4-0.1,2.4-0.9,3.3-2c1-1.2,2-2.2,3.3-3c2.9-2,5.8-3.8,8.7-5.7c1.3-0.9,0.1-3-1.2-2.1
			c-2.8,1.8-5.6,3.6-8.3,5.4c-1.2,0.8-2.4,1.7-3.4,2.8c-0.6,0.6-1.4,2.1-2.4,2.2C281.8,296.6,281.7,299,283.3,298.9L283.3,298.9z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M295.8,284.9c-1.9-4.2-6.8-4.7-10.7-5.9c-1-0.3-2.1-1-3.1-1.1c-1.1-0.1-2,0.7-2.8,1.3c-2.2,1.5-4.4,3-6.7,4.6
			c-1.3,0.9-0.1,3,1.2,2.1c1.8-1.3,3.7-2.5,5.5-3.8c0.5-0.3,1-0.7,1.4-1c0.3-0.2,0.8-0.7,1.1-0.7c0.4-0.1,0.9,0.4,1.3,0.5
			c0.5,0.2,1,0.4,1.5,0.5c3.2,1,7.6,1.3,9.2,4.7C294.3,287.5,296.4,286.3,295.8,284.9L295.8,284.9z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M278.3,297.8c-1.7-2.6-3.2-5.3-4.4-8.2c-0.6-1.4-1.2-2.8-1.7-4.3c-0.4-1.2-1.2-2.3-2.7-1.9
			c-1.2,0.3-2.4,1.2-3.5,1.8c-1.2,0.7-2.4,1.5-3.5,2.4c-2.3,1.8-3.5,4.2-5,6.7c-0.9,1.5-2.1,2.9-2.9,4.4c-0.8,1.5-1.4,3.1-1.8,4.7
			c-0.4,1.5,2,2.2,2.3,0.6c0.4-1.7,1-3.2,1.8-4.7c0.9-1.5,2-2.9,2.9-4.4c0.8-1.3,1.5-2.7,2.5-3.9c1-1.2,2.2-2.1,3.5-2.9
			c0.4-0.3,4.1-2.2,4.1-2.3c-0.1-0.1-0.3-0.1-0.4-0.2c0.1,0.2,0.1,0.3,0.2,0.5c0.2,0.4,0.3,0.9,0.5,1.3c0.3,0.8,0.6,1.5,0.9,2.3
			c1.4,3.2,3,6.3,4.9,9.3C277,300.3,279.1,299.1,278.3,297.8L278.3,297.8z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M266,314.8c2.6-6.8,7.7-12.5,14-16.1c-0.6-0.1-1.1-0.3-1.7-0.4c5.1,7.2,9.8,14.7,14,22.5
			c0.7,1.4,2.8,0.2,2.1-1.2c-4.2-7.8-8.8-15.3-14-22.5c-0.4-0.5-1.1-0.8-1.7-0.4c-6.9,3.9-12.2,10.2-15.1,17.5
			C263.1,315.6,265.5,316.2,266,314.8L266,314.8z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M281.3,333.1c5-4.9,10.3-9.7,15.8-14.1c-0.6-0.1-1.3-0.2-1.9-0.2c0.3,0.5,0.5,1.1,0.8,1.6
			c0.7,1.4,2.8,0.2,2.1-1.2c-0.3-0.5-0.5-1.1-0.8-1.6c-0.4-0.8-1.3-0.7-1.9-0.2c-5.5,4.5-10.7,9.2-15.8,14.1
			C278.5,332.5,280.2,334.2,281.3,333.1L281.3,333.1z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M259.3,313.1c-3.9-2.7-6.3-7.1-6.5-11.8c-0.1-1.4-1.9-1.6-2.4-0.3c-3,8.4-6,16.7-9,25.1
			c-0.4,1.2,1.2,1.9,2,1.2c5.7-4.8,12.9-7.2,19.4-10.6c-0.6-0.1-1.1-0.3-1.7-0.4c4.1,5.7,8.2,11.4,12.4,17.1c0.1-0.5,0.1-1,0.2-1.5
			c-3,2.4-6.1,4.6-9.2,6.7c-1.6,1-3.2,2.1-4.8,3c-0.8,0.5-1.6,1-2.4,1.5c-0.8,0.4-1.8,0.5-2.7,0.7c0.5,0.2,0.9,0.4,1.4,0.6
			c-3.6-4.8-7.3-9.6-10.9-14.4c-0.9-1.2-3,0-2.1,1.2c3.6,4.8,7.3,9.6,10.9,14.4c0.4,0.5,0.8,0.7,1.4,0.6c0.9-0.2,2-0.2,2.8-0.6
			c0.9-0.5,1.7-1,2.6-1.5c1.7-1,3.4-2.1,5.1-3.2c3.3-2.2,6.6-4.6,9.7-7.1c0.4-0.3,0.5-1.1,0.2-1.5c-4.1-5.7-8.2-11.4-12.4-17.1
			c-0.4-0.6-1-0.8-1.7-0.4c-6.7,3.5-14.1,6-19.9,11c0.7,0.4,1.4,0.8,2,1.2c3-8.4,6-16.7,9-25.1c-0.8-0.1-1.6-0.2-2.4-0.3
			c0.3,5.6,3.2,10.7,7.8,13.9C259.4,316.1,260.6,314,259.3,313.1L259.3,313.1z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M242,324.7c-0.3-0.2-0.5-0.4-0.8-0.7c-0.7-0.6-1.7-0.4-2,0.5c-3.5,10.4-3.4,21.8,0.1,32.2
			c0.3,0.9,1.3,1.2,2,0.5c3.9-3.5,7.7-6.9,11.6-10.4c1.2-1-0.6-2.8-1.7-1.7c-3.9,3.5-7.7,6.9-11.6,10.4c0.7,0.2,1.4,0.4,2,0.5
			c-3.4-10-3.4-20.9-0.1-30.9c-0.7,0.2-1.4,0.4-2,0.5c0.3,0.2,0.5,0.4,0.8,0.7C241.4,327.4,243.2,325.7,242,324.7L242,324.7z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M257.1,348.2c5.2,6.9,10.3,13.8,15.5,20.7c0.1-0.6,0.3-1.1,0.4-1.7c-5.6,4-10.8,8.6-15.2,13.9
			c0.3-0.1,0.6-0.2,0.9-0.4c-4.5-0.2-6.9-5-8.9-8.4c-2.5-4.3-4.9-8.6-7.4-12.9c-0.6-1.1-2.2-0.5-2.3,0.6c-1,10-1.7,20.6,2.5,30
			c0.3,0.6,1.2,0.8,1.7,0.4c3.8-2.8,8.1-4.6,12.7-5.4c1.5-0.3,0.9-2.6-0.6-2.3c-4.8,0.8-9.3,2.8-13.3,5.7c0.6,0.1,1.1,0.3,1.7,0.4
			c-4-9-3.2-19.3-2.2-28.8c-0.8,0.2-1.5,0.4-2.3,0.6c1.8,3.2,3.7,6.4,5.5,9.6c1.7,2.9,3.2,6.1,5.3,8.7c1,1.2,2.1,2.3,3.4,3
			c1.2,0.7,2.9,1.4,4.3,1.2c0.7-0.1,1.2-1,1.7-1.5c0.6-0.6,1.1-1.3,1.7-1.9c1.1-1.2,2.2-2.3,3.3-3.4c2.7-2.6,5.6-4.9,8.7-7.1
			c0.5-0.3,0.9-1.1,0.4-1.7c-5.2-6.9-10.3-13.8-15.5-20.7C258.3,345.8,256.2,347,257.1,348.2L257.1,348.2z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M242.8,391.8c5.4,7,11.6,13.4,18.3,19.1c-0.1-0.5-0.1-1-0.2-1.5c-0.4,0.7-0.9,1.4-1.3,2.1
			c-0.5,0.7,0,1.5,0.7,1.8c11.2,4.6,23.1,7.2,35.2,7.6c-0.4-0.4-0.8-0.8-1.2-1.2c0,0.6,0,1.1-0.1,1.7c0,0.7,0.6,1.1,1.2,1.2
			c12.4,1.3,25-1.1,36.1-6.8c3.1-1.6,6.1-3.5,8.9-5.7c0.7-0.5,0.9-1.6,0-2.1c-7.1-4.1-14.2-8.2-21.2-12.3c-1.4-0.8-2.6,1.3-1.2,2.1
			c7.1,4.1,14.2,8.2,21.2,12.3c0-0.7,0-1.4,0-2.1c-9.6,7.3-21.4,11.7-33.5,12.4c-3.4,0.2-6.8,0.1-10.2-0.3c0.4,0.4,0.8,0.8,1.2,1.2
			c0-0.6,0-1.1,0.1-1.7c0-0.7-0.6-1.2-1.2-1.2c-11.9-0.4-23.6-2.9-34.5-7.5c0.2,0.6,0.5,1.2,0.7,1.8c0.4-0.7,0.9-1.4,1.3-2.1
			c0.3-0.4,0.2-1.1-0.2-1.5c-6.7-5.8-12.8-12.2-18.3-19.1C243.6,388.9,241.9,390.6,242.8,391.8L242.8,391.8z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M341.5,405.4c6.3-5.1,10.9-12.2,12.8-20.1c0.2-0.7-0.2-1.3-0.8-1.5c-2-0.7-3.3-2.5-4.8-4
			c-1.6-1.6-3.6-2.9-5.9-2.8c-6.2,0.3-8.2,7.3-11.8,11.2c-2.1,2.3-4.6,4-7.4,5.3c-1.4,0.6-0.2,2.7,1.2,2.1
			c4.9-2.2,8.6-5.9,11.4-10.4c1.4-2.3,3-4.8,5.8-5.6c2.2-0.6,3.9,0.7,5.3,2.2c1.7,1.7,3.3,3.5,5.6,4.3c-0.3-0.5-0.6-1-0.8-1.5
			c-1.9,7.5-6.2,14.2-12.2,19C338.6,404.6,340.3,406.3,341.5,405.4L341.5,405.4z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M355,382.5c2.9-6.9,3.9-14.3,2.9-21.7c-0.2-1.1-1.7-1.1-2.2-0.3c-3.3,4.8-6.8,9.5-10.5,13.9
			c-1,1.2,0.7,2.9,1.7,1.7c3.9-4.6,7.5-9.4,10.9-14.4c-0.7-0.1-1.5-0.2-2.2-0.3c0.9,6.7,0,13.6-2.6,19.8c-0.3,0.6-0.2,1.3,0.4,1.7
			C353.8,383.3,354.7,383.1,355,382.5L355,382.5z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M355.7,358.1c-1.8-3.6-0.1-8,0.1-11.8c0.2-4.1-0.7-8.2-2.4-12c-0.3-0.7-1.4-0.8-1.9-0.2
			c-3.7,4.5-7.5,9-11.2,13.6c-1,1.2,0.7,2.9,1.7,1.7c3.7-4.5,7.5-9,11.2-13.6c-0.6-0.1-1.3-0.2-1.9-0.2c1.7,3.8,2.4,8,2,12.1
			c-0.4,3.9-1.5,7.9,0.3,11.6C354.3,360.8,356.4,359.5,355.7,358.1L355.7,358.1z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M280.7,335c5.8,3.9,11,8.8,15.2,14.5c0.4,0.6,1,0.7,1.7,0.4c0.5-0.2,1.1-0.5,1.6-0.7
			c-0.6-0.2-1.2-0.5-1.8-0.7c0.1,0.6,0.5,1,1,1.3c0.5,0.2,1.1,0.2,1.5-0.2c4.8-4.6,9.9-8.9,15.4-12.8c1.3-0.9,0.1-3-1.2-2.1
			c-5.6,4-10.9,8.4-15.9,13.2c0.5-0.1,1-0.1,1.5-0.2c0,0.1,0.1,0.1,0.1,0.2c-0.2-0.8-1.1-1-1.8-0.7c-0.5,0.2-1.1,0.5-1.6,0.7
			c0.6,0.1,1.1,0.3,1.7,0.4c-4.5-6-9.9-11.1-16.1-15.3C280.7,332,279.4,334.1,280.7,335L280.7,335z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M319,337.3c6.4,3.7,12.4,8,17.9,13c0-0.6,0-1.1,0-1.7c-5.3,5.2-10.6,10.4-15.9,15.6c-1.1,1.1,0.6,2.8,1.7,1.7
			c5.3-5.2,10.6-10.4,15.9-15.6c0.5-0.4,0.5-1.3,0-1.7c-5.6-5.1-11.8-9.6-18.4-13.4C318.9,334.5,317.6,336.6,319,337.3L319,337.3z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M302.5,385.4c2.6-2.9,5.2-5.8,7.9-8.8c2.6-2.9,5.2-6,7.9-8.8c0.6-0.6,1-0.7,1.7-0.3c0.9,0.5,1.6,1,2.5,1.6
			c1.7,1.1,3.3,2.1,5,3.2c3.4,2.2,6.7,4.3,10.1,6.5c1.3,0.9,2.5-1.3,1.2-2.1c-5.6-3.6-11.2-7.2-16.8-10.8c-1.1-0.7-2.4-1.4-3.8-0.9
			c-1.3,0.5-2.2,1.8-3.1,2.8c-2.2,2.4-4.4,4.9-6.6,7.3c-2.5,2.8-5.1,5.7-7.6,8.5C299.7,384.8,301.4,386.6,302.5,385.4L302.5,385.4z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M339.4,350.4c4,2,7.9,4.1,11.9,6.1c1.4,0.7,2.6-1.4,1.2-2.1c-4-2-7.9-4.1-11.9-6.1
			C339.2,347.5,338,349.6,339.4,350.4L339.4,350.4z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M297.1,417.6c1.7-4.5,5.9-7.4,9.7-10.1c3.8-2.7,7.2-5.7,9.1-10c0.3-0.6,0.2-1.3-0.4-1.7
			c-5.3-3-10-7-13.8-11.8c-0.3-0.4-1-0.4-1.5-0.2c-7,4-13.9,8-20.9,12c-1.4,0.8-0.1,2.9,1.2,2.1c7-4,13.9-8,20.9-12
			c-0.5-0.1-1-0.1-1.5-0.2c3.9,5,8.8,9.1,14.3,12.2c-0.1-0.6-0.3-1.1-0.4-1.7c-2,4.5-5.6,7.2-9.5,10c-3.9,2.8-7.8,6-9.6,10.7
			C294.2,418.4,296.6,419,297.1,417.6L297.1,417.6z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M263.2,409.9c6.8-0.8,12.6-5.7,14.4-12.3c-0.6,0.2-1.2,0.5-1.8,0.7c6.6,5,13.3,10.1,19.9,15.1
			c1.2,0.9,2.5-1.2,1.2-2.1c-6.6-5-13.3-10.1-19.9-15.1c-0.6-0.5-1.6,0-1.8,0.7c-1.5,5.5-6.4,9.9-12,10.5
			C261.7,407.6,261.7,410.1,263.2,409.9L263.2,409.9z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M257.3,384c3.6,6.4,8.9,11.8,15.3,15.5c1.4,0.8,2.6-1.3,1.2-2.1c-6-3.5-11-8.5-14.4-14.6
			C258.6,381.4,256.5,382.6,257.3,384L257.3,384z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M275.9,369.3c1.3,0,2.5-0.3,3.7-1c-0.6-0.1-1.1-0.3-1.7-0.4c3.9,8.4,11,15,19.7,18.4c1.5,0.6,2.1-1.8,0.6-2.3
			c-8-3.1-14.6-9.4-18.2-17.2c-0.3-0.6-1.1-0.8-1.7-0.4c-0.8,0.5-1.5,0.7-2.4,0.7C274.3,366.9,274.3,369.3,275.9,369.3L275.9,369.3z
			"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M281.8,366.8c2.6-3,5.3-5.9,7.9-8.9c1.4-1.5,2.7-3.1,4.1-4.6c0.8-0.9,2-2.4,3.5-1.9c0.7,0.3,1.4,0.9,1.9,1.4
			c0.7,0.6,1.3,1.2,2,1.8c1.5,1.4,3,2.7,4.5,4.1c2.9,2.6,5.8,5.3,8.7,7.9c1.2,1.1,2.9-0.7,1.7-1.7c-5-4.5-9.9-9-14.9-13.6
			c-1-0.9-2-1.9-3.3-2.3c-1.3-0.4-2.6-0.1-3.7,0.7c-1.2,0.8-2.1,1.9-3,2.9c-1.2,1.3-2.3,2.6-3.5,3.9c-2.6,2.9-5.1,5.7-7.7,8.6
			C279,366.2,280.7,367.9,281.8,366.8L281.8,366.8z"
            />
          </g>
          <g>
            <path
              className="st0"
              d="M280.9,332.3c-2.6-1.7-6.3-1.2-8.4,1c-0.4,0.5-0.5,1.3,0,1.7c0.5,0.4,1.2,0.5,1.7,0c0.1-0.1,0.2-0.2,0.3-0.3
			c0.1-0.1,0.1-0.1,0.2-0.2c-0.1,0.1-0.1,0.1,0,0c0.2-0.2,0.5-0.3,0.7-0.4c0,0,0.3-0.1,0.1-0.1c-0.1,0.1,0.1,0,0.1,0
			c0.1-0.1,0.3-0.1,0.4-0.1c0.2,0,0.3-0.1,0.5-0.1c0.1,0,0.1,0,0.2,0c0.2,0-0.1,0,0,0c0.3,0,0.6,0,0.9,0c0.1,0,0.3,0,0.4,0
			c-0.3,0,0.1,0,0.2,0c0.1,0,0.3,0.1,0.4,0.1c0.1,0,0.1,0,0.2,0.1c0,0,0.3,0.1,0.1,0c-0.1-0.1,0,0,0.1,0c0.1,0,0.1,0.1,0.2,0.1
			c0.1,0.1,0.3,0.2,0.4,0.2c0.5,0.3,1.4,0.1,1.7-0.4C281.7,333.3,281.5,332.6,280.9,332.3L280.9,332.3z"
            />
          </g>
        </g>
        <path
          id="BOLD_OF_FUTURE_BOLD_1_"
          className="st1 text"
          d="M120.2,518.5l3.4,2.3c0.5,0.4,1.3,0.3,1.7-0.2c0,0,0.1-0.1,0.1-0.1l14.5-21.1
	l22.9,15.8l-14.5,21.1c-0.4,0.5-0.3,1.3,0.2,1.7c0,0,0.1,0.1,0.1,0.1l3.4,2.3c0.5,0.4,1.3,0.3,1.7-0.2c0,0,0.1-0.1,0.1-0.1
	l32.3-46.9c0.4-0.5,0.3-1.3-0.2-1.7c0,0-0.1-0.1-0.1-0.1l-3.4-2.3c-0.5-0.4-1.3-0.3-1.7,0.2c0,0-0.1,0.1-0.1,0.1l-14.3,20.8
	l-22.9-15.8l14.3-20.8c0.4-0.5,0.3-1.3-0.2-1.7c0,0-0.1-0.1-0.1-0.1l-3.4-2.3c-0.5-0.4-1.3-0.3-1.7,0.2c0,0-0.1,0.1-0.1,0.1
	l-32.3,46.9c-0.4,0.5-0.3,1.3,0.2,1.7C120.2,518.4,120.2,518.4,120.2,518.5z M95.5,493.6l41.2-39.4c0.5-0.4,0.6-1.2,0.1-1.7
	c0,0-0.1-0.1-0.1-0.1l-2.8-2.9c-0.4-0.5-1.2-0.6-1.7-0.1c0,0-0.1,0.1-0.1,0.1l-41.2,39.4c-0.5,0.4-0.6,1.2-0.1,1.7
	c0,0,0.1,0.1,0.1,0.1l2.8,2.9c0.4,0.5,1.2,0.6,1.7,0.1C95.4,493.6,95.4,493.6,95.5,493.6z M63.5,401.5l12.8,21.8
	c0.3,0.6,1,0.8,1.6,0.5c0,0,0.1,0,0.1-0.1l3-1.8c0.6-0.3,0.8-1,0.5-1.6c0,0,0-0.1-0.1-0.1l-10.3-17.4c10-5.5,21.4-2,27.5,8.4
	c6.5,11.7,2.3,26.4-9.3,32.9c-11.3,6.3-25.5,2.6-32.3-8.3c-2.9-5-3.9-10.9-2.8-16.6c0.2-0.6-0.1-1.3-0.7-1.5c-0.1,0-0.1,0-0.2,0
	l-3.6-0.9c-0.6-0.2-1.2,0.1-1.4,0.7c0,0.1-0.1,0.2-0.1,0.3c-1.6,7.3-0.4,14.9,3.2,21.4c8.9,14.4,27.8,18.8,42.2,9.9
	c14-8.6,18.6-26.8,10.6-41.1c-8.6-14.7-24.5-17.4-38.1-9.4l-2.3,1.3c-0.6,0.3-0.8,1-0.5,1.6C63.4,401.4,63.4,401.5,63.5,401.5
	L63.5,401.5z M16.3,340.5l0.9,4c0.1,0.7,0.7,1.1,1.4,1c0,0,0.1,0,0.1,0l24.9-5.7l6.2,27.1L25,372.5c-0.7,0.1-1.1,0.7-1,1.4
	c0,0,0,0.1,0,0.1l0.9,4c0.1,0.7,0.7,1.1,1.4,1c0,0,0.1,0,0.1,0L82,366.2c0.7-0.1,1.1-0.7,1-1.4c0,0,0-0.1,0-0.1l-0.9-4
	c-0.1-0.7-0.7-1.1-1.4-1c0,0-0.1,0-0.1,0l-24.6,5.7l-6.2-27.1l24.6-5.7c0.7-0.1,1.1-0.7,1-1.4c0,0,0-0.1,0-0.1l-0.9-4
	c-0.1-0.7-0.7-1.1-1.4-1c0,0-0.1,0-0.1,0l-55.5,12.8c-0.7,0.1-1.1,0.7-1,1.4C16.3,340.4,16.3,340.4,16.3,340.5z M67.2,275l-0.6,22.3
	l-52.1-1.4c-0.7-0.1-1.2,0.4-1.3,1.1c0,0,0,0.1,0,0.1l-0.1,4.1c-0.1,0.7,0.4,1.2,1.1,1.3c0,0,0.1,0,0.1,0l56.9,1.5
	c0.7,0.1,1.2-0.4,1.3-1.1c0,0,0-0.1,0-0.1l0.7-27.6c0.1-0.7-0.4-1.2-1.1-1.3c0,0-0.1,0-0.1,0l-3.6-0.1c-0.7-0.1-1.2,0.4-1.3,1.1
	C67.2,274.9,67.2,275,67.2,275L67.2,275z M19.7,242.5l55.8,11.4c0.6,0.2,1.3-0.2,1.5-0.9c0,0,0-0.1,0-0.1l0.8-4
	c0.2-0.6-0.2-1.3-0.8-1.5c0,0-0.1,0-0.1,0L21.1,236c-0.6-0.2-1.3,0.2-1.5,0.9c0,0,0,0.1,0,0.1l-0.8,4c-0.2,0.6,0.2,1.3,0.9,1.5
	C19.6,242.5,19.7,242.5,19.7,242.5z M77.1,163.8l-10.5,22.9c-0.3,0.6-0.1,1.3,0.5,1.6c0,0,0.1,0,0.1,0.1l3.2,1.5
	c0.6,0.3,1.3,0.1,1.6-0.5c0,0,0-0.1,0.1-0.1l8.4-18.4c10.2,5.1,13.9,16.4,8.8,27.4c-6,12-20.5,16.8-32.4,10.9
	c-11.4-5.7-16.4-19.2-11.5-31c2.4-5.3,6.7-9.4,12-11.8c0.6-0.2,1-0.8,0.8-1.4c0-0.1,0-0.1-0.1-0.2l-1.3-3.5
	c-0.2-0.6-0.8-0.9-1.4-0.8c-0.1,0-0.2,0.1-0.3,0.1c-6.9,2.9-12.5,8.2-15.7,14.9C32.8,191,40,209,55.5,215.7
	c15,6.4,32.4-0.1,39.6-14.7c7.1-15.4,0.3-30.1-14-36.7l-2.4-1.1c-0.6-0.3-1.3-0.1-1.6,0.5C77.1,163.7,77.1,163.8,77.1,163.8
	L77.1,163.8z M100.5,90.2l-2.7,3c-0.5,0.5-0.5,1.2,0,1.7c0,0,0.1,0.1,0.1,0.1l18.9,17.2L98,132.8l-18.9-17.2c-0.5-0.5-1.2-0.5-1.7,0
	c0,0-0.1,0.1-0.1,0.1l-2.7,3c-0.5,0.5-0.5,1.2,0,1.7c0,0,0.1,0.1,0.1,0.1l42.1,38.3c0.5,0.5,1.2,0.5,1.7,0c0,0,0.1-0.1,0.1-0.1
	l2.7-3c0.5-0.5,0.5-1.2,0-1.7c0,0-0.1-0.1-0.1-0.1l-18.7-17l18.7-20.5l18.7,17c0.5,0.5,1.2,0.5,1.7,0c0,0,0.1-0.1,0.1-0.1l2.7-3
	c0.5-0.5,0.5-1.2,0-1.7c0,0-0.1-0.1-0.1-0.1l-42.1-38.4c-0.5-0.5-1.2-0.5-1.7,0C100.5,90.1,100.5,90.1,100.5,90.2L100.5,90.2z
	 M158.2,47.7l-28.3,18.2c-0.6,0.3-0.8,1.1-0.5,1.6c0,0,0.1,0.1,0.1,0.1l1.9,3c0.3,0.6,1.1,0.8,1.6,0.5c0,0,0.1,0,0.1-0.1l11.4-7.3
	l28.1,43.9c0.3,0.6,1.1,0.8,1.6,0.5c0,0,0.1,0,0.1-0.1l3.4-2.2c0.6-0.3,0.8-1.1,0.5-1.6c0,0,0-0.1-0.1-0.1l-28.1-43.9l11.4-7.3
	c0.6-0.3,0.8-1.1,0.5-1.6c0,0-0.1-0.1-0.1-0.1l-1.9-3c-0.3-0.6-1-0.8-1.6-0.5C158.2,47.6,158.2,47.6,158.2,47.7L158.2,47.7z
	 M197.6,45.2c-1.9-5.5,1.5-10.2,7.2-12.3c4.7-1.5,9.8-1,14.1,1.4c0.5,0.3,1.2,0.1,1.5-0.4c0.1-0.1,0.1-0.2,0.1-0.3l1.3-2.8
	c0.4-0.5,0.2-1.3-0.3-1.6c-0.1,0-0.1-0.1-0.2-0.1c-5.6-3.3-12.4-4-18.5-2c-9.2,3.2-14.1,11.7-11.2,20c6.4,18.1,33.5,4.1,38.2,17.7
	c1.9,5.5-1.3,11.7-8.7,14.3c-5.2,1.6-10.8,1-15.5-1.8c-0.5-0.4-1.3-0.3-1.6,0.3c0,0.1-0.1,0.1-0.1,0.2l-1.5,3.1
	c-0.4,0.5-0.3,1.2,0.2,1.6c0,0,0.1,0.1,0.1,0.1c6,4.2,13.7,5.1,20.5,2.3c10.1-3.5,15.9-13.2,12.9-21.9
	C229.5,44,202.2,58.4,197.6,45.2L197.6,45.2z M340.4,69.8l-6.3-8c2.5-2.6,4.9-5.3,7.1-8.2c0.5-0.4,0.5-1.1,0.1-1.6
	c0,0-0.1-0.1-0.1-0.1l-2.7-2.3c-0.4-0.4-1-0.3-1.4,0c-0.1,0.1-0.1,0.2-0.2,0.3c-1.9,2.6-4,5.1-6.3,7.4L316.2,39
	c6.1-3.6,11.5-7.6,12-14.1c0.2-7.2-5.5-13.2-12.6-13.4c0,0,0,0,0,0c-6.9-1-13.3,3.8-14.2,10.7c0,0.2,0,0.3-0.1,0.5
	c-0.4,4.8,2.6,9.8,6.2,14.5c-7,3.9-14.1,8.5-14.7,17.2c-0.9,10.8,7.5,17,17.3,17.8c7.2,0.4,14.3-2,19.8-6.7l6.2,7.9
	c0.3,0.5,1,0.7,1.5,0.3c0.1-0.1,0.2-0.1,0.2-0.2l2.4-2c0.5-0.4,0.7-1.1,0.3-1.6C340.5,69.9,340.4,69.8,340.4,69.8L340.4,69.8z
	 M307.4,23.3c0.4-3.7,3.8-6.4,7.5-5.9c0.1,0,0.1,0,0.2,0c3.9,0,7,3.1,7,6.9c0,0,0,0.1,0,0.1c-0.3,4.3-4.5,7.1-9.6,10
	C309.8,30.8,307.1,26.8,307.4,23.3L307.4,23.3z M310.9,66.3c-6.6-0.5-12.2-4.8-11.7-11.5c0.5-5.8,5.9-9.3,11.9-12.8l15,19
	C321.9,64.6,316.5,66.4,310.9,66.3L310.9,66.3z M452.9,57.3l-3.6-2c-0.6-0.4-1.3-0.2-1.7,0.4c0,0,0,0.1-0.1,0.1l-12.5,22.3
	l-24.3-13.5l12.5-22.3c0.4-0.6,0.2-1.3-0.4-1.7c0,0-0.1,0-0.1-0.1l-3.6-2c-0.6-0.4-1.3-0.2-1.7,0.4c0,0-0.1,0.1-0.1,0.1l-27.8,49.7
	c-0.4,0.6-0.2,1.3,0.4,1.7c0,0,0.1,0.1,0.1,0.1l3.6,2c0.6,0.4,1.3,0.2,1.7-0.4c0,0,0-0.1,0.1-0.1l12.3-22l24.3,13.5l-12.3,22
	c-0.4,0.6-0.2,1.3,0.4,1.7c0,0,0.1,0,0.1,0.1l3.6,2c0.6,0.4,1.3,0.2,1.7-0.4c0,0,0-0.1,0.1-0.1L453.4,59c0.4-0.6,0.2-1.3-0.4-1.7
	C453,57.3,453,57.3,452.9,57.3L452.9,57.3z M475.7,154.7l26-54.9c0.3-0.6,0.2-1.3-0.3-1.8l-3-3c-0.5-0.5-1.2-0.7-1.8-0.4l-55.3,25.1
	c-0.5,0.1-0.8,0.7-0.7,1.2c0.1,0.2,0.2,0.4,0.4,0.5l2.9,2.9c0.4,0.5,1.2,0.7,1.7,0.3l12.7-5.9l18.7,19l-6.1,12.6
	c-0.3,0.6-0.2,1.3,0.3,1.7l2.9,2.9c0.3,0.4,0.9,0.6,1.4,0.3C475.5,155.1,475.6,154.9,475.7,154.7L475.7,154.7z M463.4,116.3
	l30.6-14.2l-14.7,30.4L463.4,116.3z M545.3,157.2l-7.8-14c-0.3-0.6-1-0.9-1.6-0.6c0,0-0.1,0-0.1,0.1l-49.7,27.7
	c-0.6,0.3-0.8,1-0.6,1.6c0,0,0,0.1,0.1,0.1l2,3.6c0.3,0.6,1,0.9,1.6,0.6c0,0,0.1,0,0.1-0.1l18.6-10.4l5.2,9.3
	c6.3,11.3,16.6,13.5,25.8,8.4C548.1,178.4,551.6,168.5,545.3,157.2z M518.3,171.9l-5-9l21.5-12l5,9c3.7,6.7,3.7,13.7-4.1,18
	C528,182.3,522,178.6,518.3,171.9L518.3,171.9z M571.9,222.9l-4.1-15.4c-0.1-0.7-0.8-1.1-1.4-0.9c0,0-0.1,0-0.1,0l-55,14.6
	c-0.7,0.1-1.1,0.8-0.9,1.4c0,0,0,0.1,0,0.1l1,3.9c0.1,0.6,0.8,1.1,1.4,0.9c0,0,0.1,0,0.1,0l20.6-5.5l2.7,10.3
	c3.3,12.5,12.7,17.2,22.9,14.5C569.4,244.2,575.2,235.4,571.9,222.9L571.9,222.9z M542.1,230.5l-2.6-9.9l23.8-6.3l2.6,9.9
	c2,7.4,0.2,14.2-8.4,16.5S544,237.9,542.1,230.5L542.1,230.5z M528.3,307l-0.4-24l22.4-0.4l0.4,22.4c0,0.7,0.5,1.2,1.2,1.3
	c0.1,0,0.1,0,0.2,0l3.6-0.1c0.7,0,1.2-0.5,1.3-1.2c0-0.1,0-0.1,0-0.2l-0.4-22.4l18.8-0.3l0.4,23.9c0,0.7,0.5,1.2,1.2,1.3
	c0.1,0,0.1,0,0.2,0l3.6-0.1c0.7,0,1.2-0.5,1.3-1.2c0-0.1,0-0.1,0-0.2l-0.5-29.2c0-0.7-0.5-1.2-1.1-1.3c-0.1,0-0.1,0-0.2,0l-56.9,0.9
	c-0.7,0-1.2,0.5-1.3,1.1c0,0.1,0,0.1,0,0.2l0.5,29.3c0,0.7,0.5,1.2,1.2,1.3c0,0,0.1,0,0.1,0l3.6-0.1c0.7,0,1.2-0.5,1.3-1.2
	C528.3,307.1,528.3,307.1,528.3,307L528.3,307z M567.7,385.3l1-4c0.2-0.6-0.1-1.3-0.8-1.5c0,0-0.1,0-0.1,0l-47.2-12l54.7-16
	c0.6-0.2,1.1-0.7,1.2-1.3l1.4-5.5c0.1-0.6-0.4-1.2-1-1.3l-55.2-14c-0.6-0.2-1.3,0.1-1.5,0.8c0,0,0,0.1,0,0.1l-1,4
	c-0.2,0.6,0.1,1.3,0.8,1.5c0,0,0.1,0,0.1,0l47.2,12l-54.7,16c-0.6,0.2-1.1,0.7-1.2,1.3l-1.4,5.5c-0.1,0.6,0.4,1.2,1,1.3l55.2,14
	c0.6,0.2,1.3-0.2,1.5-0.8C567.7,385.4,567.7,385.3,567.7,385.3L567.7,385.3z M552.7,417.2l-51.1-25c-0.6-0.3-1.3-0.1-1.6,0.5
	c0,0,0,0.1-0.1,0.1l-1.8,3.7c-0.3,0.6-0.1,1.3,0.4,1.6c0,0,0.1,0,0.1,0.1l51.1,25c0.6,0.3,1.3,0.1,1.6-0.5c0,0,0-0.1,0.1-0.1
	l1.8-3.7c0.3-0.6,0.1-1.3-0.4-1.6C552.8,417.3,552.7,417.2,552.7,417.2L552.7,417.2z M508.2,487.2l2.5-3.2c0.4-0.5,0.4-1.3-0.1-1.7
	c0,0-0.1-0.1-0.1-0.1l-38.3-30l56.6,7.5c0.6,0.1,1.3-0.2,1.6-0.7l3.5-4.5c0.3-0.5,0.1-1.2-0.4-1.6l-44.8-35.1
	c-0.5-0.4-1.3-0.4-1.7,0.1c0,0-0.1,0.1-0.1,0.1l-2.5,3.2c-0.4,0.5-0.4,1.3,0.1,1.7c0,0,0.1,0.1,0.1,0.1l38.3,30l-56.6-7.5
	c-0.6-0.1-1.3,0.2-1.6,0.7l-3.5,4.5c-0.3,0.5-0.1,1.2,0.4,1.6l44.8,35.1c0.5,0.4,1.3,0.4,1.7-0.1
	C508.1,487.3,508.1,487.3,508.2,487.2L508.2,487.2z M416.9,523l21-14.1c0.6-0.3,0.8-1.1,0.4-1.6c0,0-0.1-0.1-0.1-0.1l-1.9-2.9
	c-0.3-0.6-1.1-0.8-1.7-0.4c0,0-0.1,0-0.1,0.1l-16.8,11.3c-6.1-9.6-3.3-21.2,6.7-28c11.3-7.1,26.2-3.7,33.4,7.6
	c6.8,10.8,4,25.1-6.3,32.5c-4.8,3.2-10.7,4.5-16.4,3.7c-0.6-0.2-1.3,0.2-1.4,0.8c0,0.1,0,0.1,0,0.2l-0.7,3.7
	c-0.2,0.6,0.2,1.2,0.8,1.4c0.1,0,0.2,0,0.3,0c7.4,1.1,14.9-0.5,21.2-4.5c13.8-9.8,17.1-28.9,7.3-42.7c-9.5-13.3-27.7-16.9-41.5-8.1
	c-14.1,9.5-16,25.5-7.2,38.6l1.5,2.2c0.3,0.6,1.1,0.8,1.6,0.4C416.8,523.1,416.9,523,416.9,523z M389,549.4c1.8,5.6-1.8,10.2-7.6,12
	c-4.7,1.4-9.9,0.7-14.1-1.9c-0.5-0.3-1.2-0.2-1.5,0.3c-0.1,0.1-0.1,0.2-0.1,0.3l-1.4,2.7c-0.4,0.5-0.2,1.3,0.3,1.6
	c0.1,0,0.1,0.1,0.2,0.1c5.5,3.5,12.2,4.4,18.5,2.6c9.3-2.9,14.5-11.2,11.8-19.6c-5.8-18.3-33.3-5.2-37.7-18.9
	c-1.8-5.6,1.7-11.7,9.1-14c5.2-1.4,10.8-0.6,15.4,2.3c0.5,0.4,1.3,0.3,1.7-0.2c0,0,0.1-0.1,0.1-0.1l1.6-3c0.4-0.5,0.3-1.2-0.2-1.6
	c0,0-0.1-0.1-0.1-0.1c-5.9-4.4-13.6-5.5-20.5-3c-10.2,3.2-16.3,12.7-13.6,21.5C357,549.5,384.8,536,389,549.4L389,549.4z
	 M247.1,520.1l6.1,8.2c-2.6,2.5-5.1,5.2-7.4,8c-0.5,0.4-0.5,1.1-0.1,1.6c0,0,0.1,0.1,0.1,0.1l2.6,2.4c0.4,0.4,1,0.4,1.4,0
	c0.1-0.1,0.1-0.2,0.2-0.3c2-2.6,4.2-5,6.5-7.2l13.7,18.7c-6.2,3.4-11.8,7.2-12.5,13.7c-0.4,7.2,5,13.3,12.2,13.8c0,0,0,0,0,0
	c6.9,1.2,13.4-3.4,14.6-10.2c0-0.2,0.1-0.3,0.1-0.5c0.5-4.8-2.3-9.8-5.7-14.7c7.2-3.6,14.3-8.1,15.3-16.7
	c1.2-10.7-6.9-17.3-16.7-18.4c-7.2-0.7-14.4,1.5-20,6l-5.9-8.1c-0.3-0.5-1-0.7-1.5-0.4c-0.1,0.1-0.2,0.1-0.2,0.2l-2.4,2
	c-0.6,0.3-0.7,1.1-0.4,1.6C247,520,247,520,247.1,520.1z M278.5,567.6c-0.6,3.7-4,6.2-7.7,5.6c-0.1,0-0.1,0-0.2,0
	c-3.9-0.1-6.9-3.3-6.8-7.1c0,0,0-0.1,0-0.1c0.5-4.3,4.7-7,9.9-9.7C276.3,560,278.9,564.1,278.5,567.6L278.5,567.6z M276.4,524.6
	c6.6,0.7,12.1,5.2,11.3,11.9c-0.7,5.7-6.2,9.2-12.3,12.4L261,529.3C265.4,525.9,270.9,524.2,276.4,524.6z"
        />
      </svg>
    </Container>
  )
}

export default Pineapple
